/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button, Table, Drawer, Popconfirm, Popover, Select,
} from 'antd';
import { DeleteOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import QCPointActions from '@Actions/quality/qcPointActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import NoBom from '@Images/NoBOM.png';
import QCPointForm from '../../../../Quality/QualityControlPoints/QCPointForm';
import UpdateProductGroup from '../../../../Quality/QualityControlPoints/UpdateProductGroup';
import './style.scss';
import SelectQualityRule from '@Components/Common/SelectQualityRule';
import Crown from '@Images/crown2.png';

const { Option } = Select;

/**
 *
 */
const QCRule = ({
  user, match, getQCPoints, qualityControlPoints, qualityControlPointsLoading, getQCPointBySkuId, getQCPointBySkuIdLoading, qcPointsBySkuId, updateQCPointProduct, updateQCPointProductLoading, deleteQCPoint, deleteQCPointLoading, selectedProduct,
}) => {
  const [showNewQCPointModal, setShowNewQCPointModal] = useState(false);
  const [showUpdateQCPointModal, setShowUpdateQCPointModal] = useState(false);
  const [selectedQCPoint, setSelectedQCPoint] = useState({});
  const [showUpdateProductGroupModal, setShowUpdateProductGroupModal] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [forExistingQCRules, setForExistingQCRules] = useState(false);
  const [selectedQCRule, setSelectedQCRule] = useState();
  const [call, setCall] = useState(false);

  const { productSkuId } = match.params;

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      getQCPointBySkuId(user?.tenant_info?.tenant_id, productSkuId);
    }
  }, [call]);

  useEffect(() => {
    if (forExistingQCRules) {
      getQCPoints(user?.tenant_info?.tenant_id, '', '', '', '', '', '', '', 1, 100);
    }
  }, [forExistingQCRules]);

  const getOperationLabel = (operation) => {
    switch (operation) {
    case 'good_receiving_note':
      return 'Purchase Receipt';
    case 'manufacturing_order':
      return 'Manufacturing Order';
    case 'good_receiving_note_internal_stock_transfer':
      return 'Internal Transfer Receipt';
    case 'good_receiving_note_external_stock_transfer':
      return 'External Transfer Receipt';
    default:
      return '-';
    }
  };

  const getQCPointColumns = () => {
    const qcPointColumns = [
      {
        title: '',
        render: (record) => (
          <Link to={`/sales/sales-order/view/${record.order_id}`}>
            <div className="mobile-list__item">
              <div style={{ display: 'flex' }}>
                <H3Text text={`#${record?.qcr_number}`} className="mobile-list__item-number" />
              </div>
              {record?.quality_control_name && (
                <div className="mobile-list__item-info">
                  {`Title - ${record?.quality_control_name}`}
                </div>
              )}
              <H3Text
                text={(
                  <div>
                    Operation -&nbsp;
                    {record?.operations?.map((operation) => (
                      <span key={record?.operation} className="qc-tags">
                        {operation === 'good_receiving_note' ? 'GRN' : (operation === 'manufacturing_order' ? 'MO' : '-')}
                        &nbsp;
                      </span>
                    ))}
                  </div>
                )}
                className="mobile-list__item-info"
              />
              <H3Text
                text={`Control Frequency - ${record?.control_frequency}`}
                className="mobile-list__item-info"
              />
            </div>
          </Link>
        ),
        responsive: ['xs'],
      },
      {
        title: 'QC RULE #',
        // width: '120px',
        dataIndex: 'qcr_number',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        fixed: 'left',
      },
      {
        title: 'TITLE',
        // width: '250px',
        render: (text, record) => (
          <div className="">
            {record?.quality_control_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'OPERATIONS',
        // width: '450px',
        render: (text, record) => (
          <Fragment>
            <div className="qc-tags__wrapper">
              {record?.operations?.map((operation) => (
                <div key={record?.operation} className="qc-tags">
                  {getOperationLabel(operation)}
                </div>
              ))}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'CONTROL FREQUENCY',
        render: (text, record) => (
          <div className="">
            {record?.control_frequency}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        fixed: 'right',
        render: (record) => (
          <div className="list__actions" style={{ alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
              Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="list__actions-button"
                onClick={() => {
                  setShowUpdateQCPointModal(true);
                  setSelectedQCPoint(record);
                }}
              >
                <EditOutlined />
              </div>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
              Helpers.permissionTypes.DELETE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this Quality Control Rule?"
                onConfirm={() => {
                  const payload = {
                    tenant_id: user?.tenant_info?.tenant_id,
                    product_sku_id: selectedProduct?.product_sku_id,
                  };
                  deleteQCPoint(payload, () => {
                    setCall(!call);
                  });
                }}
                okText="Yes"
                cancelText="No"
              >
                <div
                  className="list__actions-button-delete"
                >
                  {deleteQCPointLoading ? <LoadingOutlined /> : <DeleteOutlined />}
                </div>
              </Popconfirm>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];
    return qcPointColumns;
  };

  const qualityControl = user?.tenant_info?.quality_control_config?.sub_modules?.quality_control_rule?.is_active;

  return (
    <Fragment>
      {getQCPointBySkuIdLoading ? <Table loading /> : (
        <div className="product-qc__wrapper">
          {((Number(qcPointsBySkuId?.count || 0) === 0)) ? (
            <div className="product-qc__no-bom-wrapper">
              <div className="product-qc__no-bom">
                <img className="product-qc__no-bom__image" src={NoBom} alt="quality check rule" />
                <H3Text className="product-qc__no-bom__text" text="No Quality Check rule has been created for this product" />
                <div className="product-qc__no-bom__button-wrapper">
                  {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
                    Helpers.permissionTypes.CREATE, user) && (
                    <div className="product-qc__no-bom__button hide__in-mobile">
                      <Button
                        className="product-qc__no-bom__button-left hide__in-mobile"
                        onClick={() => {
                          setShowNewQCPointModal(true);
                        }}
                        type="primary"
                      >
                        + New Quality Rule
                      </Button>
                    </div>
                  )}
                  {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
                    Helpers.permissionTypes.UPDATE, user) && (
                    <Popover
                      placement="topRight"
                      trigger="click"
                      title={<div style={{ width: '280px' }}>Select quality check rule</div>}
                      open={openPopover}
                      content={(
                        <React.Fragment>
                          <div>
                            <SelectQualityRule
                              selectedQCRule={selectedQCRule}
                              onChange={(value) => {
                                setSelectedQCRule(value);
                                getQCPoints(user?.tenant_info?.tenant_id, null, null, null, null, null, null, null, 1, 100, null);
                              }}
                            />
                          </div>
                          <div style={{ display: 'flex', marginTop: '10px' }}>
                            <H3Button
                              text="Add"
                              buttonType={defaultButtonTypes.BLUE_ROUNDED}
                              onClick={() => {
                                if (qualityControl) {
                                  const payload = {
                                    group_id: selectedQCRule,
                                    product_sku_id: productSkuId,
                                  };
                                  updateQCPointProduct(payload, () => {
                                    getQCPointBySkuId(user?.tenant_info?.tenant_id, productSkuId);
                                  });
                                  setOpenPopover(false);
                                }
                              }}
                              customClass="qc-submit"
                              isLoading={updateQCPointProductLoading}
                              disabled={updateQCPointProductLoading}
                            />
                            {!qualityControl && (
                              <Popconfirm
                                placement="topRight"
                                title="This feature is not accessible within your current plan to use this feature contact us."
                                onConfirm={() => window.Intercom('showNewMessage')}
                                okText="Contact Us"
                                cancelText="Cancel"
                              >
                                <img className="barcode-restrict" style={{ marginTop: '15px', marginLeft: '4px' }} src={Crown} alt="premium" />
                              </Popconfirm>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                    >
                      <div className="product-qc__no-bom__button hide__in-mobile">
                        <Button
                          className="product-qc__no-bom__button-right hide__in-mobile"
                          onClick={() => {
                            setOpenPopover(!openPopover);
                            setForExistingQCRules(true);
                          }}
                          type="primary"
                          loading={updateQCPointProductLoading}
                        >
                          + Add to Existing Rule
                        </Button>
                      </div>
                    </Popover>
                  )}
                </div>
              </div>
            </div>
          )
            : (
              <div className="generic-table-container">
                <Table
                  loading={qualityControlPointsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  tableLayout="unset"
                  top="none"
                  columns={getQCPointColumns()}
                  dataSource={qcPointsBySkuId && qcPointsBySkuId?.quality_control_rules ? qcPointsBySkuId?.quality_control_rules : []}
                  title={() => (
                    <div className="product-qc__table-header">
                      {`${(qcPointsBySkuId && qcPointsBySkuId?.count) ? qcPointsBySkuId?.count : '0'} Total Quality Control Rules`}
                    </div>
                  )}
                />
              </div>
            )}
        </div>
      )}
      <Drawer
        visible={showNewQCPointModal}
        onClose={() => setShowNewQCPointModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Create Quality Control Rule" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewQCPointModal(false)} />
          </div>
        </div>
        <QCPointForm
          productSkuId={productSkuId}
          callback={() => {
            getQCPointBySkuId(user?.tenant_info?.tenant_id, productSkuId);
            setShowNewQCPointModal(false);
          }}
        />
      </Drawer>
      <Drawer
        visible={showUpdateQCPointModal}
        onClose={() => setShowUpdateQCPointModal(false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text text="Update Quality Control Point" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateQCPointModal(false)} />
          </div>
        </div>
        <QCPointForm
          selectedQCPoint={selectedQCPoint}
          callback={() => {
            getQCPointBySkuId(user?.tenant_info?.tenant_id, productSkuId);
            setShowUpdateQCPointModal(false);
          }}
        />
      </Drawer>
      <Drawer
        visible={showUpdateProductGroupModal}
        onClose={() => setShowUpdateProductGroupModal(false)}
        width="400px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '355px' }}>
            <H3Text text="Update Product Group" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateProductGroupModal(false)} />
          </div>
        </div>
        <UpdateProductGroup
          productsGroup={selectedQCPoint?.products}
          selectedQCPoint={selectedQCPoint}
          onClose={() => {
            getQCPointBySkuId(user?.tenant_info?.tenant_id, productSkuId);
            setShowUpdateProductGroupModal(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, QCPointReducers, ProductReducers }) => ({
  user: UserReducers.user,
  qualityControlPointsLoading: QCPointReducers.qualityControlPointsLoading,
  qualityControlPoints: QCPointReducers.qualityControlPoints,
  deleteQCPointLoading: QCPointReducers.deleteQCPointLoading,
  selectedProduct: ProductReducers.selectedProduct,
  qcPointsBySkuId: QCPointReducers.qcPointsBySkuId,
  updateQCPointProductLoading: QCPointReducers.updateQCPointProductLoading,
  getQCPointBySkuIdLoading: QCPointReducers.getQCPointBySkuIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getQCPoints: (tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword) => dispatch(
    QCPointActions.getQCPoints(tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword),
  ),
  deleteQCPoint: (payload, callback) => dispatch(QCPointActions.deleteQCPoint(payload, callback)),
  getQCPointBySkuId: (tenantId, productSkuId) => dispatch(QCPointActions.getQCPointBySkuId(tenantId, productSkuId)),
  updateQCPointProduct: (payload, callback) => dispatch(QCPointActions.updateQCPointProduct(payload, callback)),
});

QCRule.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
  getQCPoints: PropTypes.func,
  getQCPointBySkuId: PropTypes.func,
  updateQCPointProduct: PropTypes.func,
  updateQCPointProductLoading: PropTypes.bool,
  qualityControlPoints: PropTypes.any,
  qcPointsBySkuId: PropTypes.any,
  qualityControlPointsLoading: PropTypes.bool,
  getQCPointBySkuIdLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCRule));
